import instance from "../globals/axios";

export const getAreaManagerVles = async (area_manager_id) => {
  const url = `/usermanagement/get-sub-users?area_manager_id=${area_manager_id}&vles=true`;
  const response = await instance.get(url);
  return response.data;
};
